import { defineStore } from "pinia";
import type { Unread } from "~/slices/users/types";

/**
 * Unread state is driven by Vue Query (useUnread in slices/users/composables/api.ts).
 * This store is synced from the query so components can read unreadStore.unread.
 * To refetch, use queryClient.invalidateQueries({ queryKey: ['unread'] }) or useUnread().invalidate().
 */
export const useUnreadStore = defineStore("unread", () => {
  const unread: Ref<Unread | null> = ref(null);

  const setUnread = (newUnread: Unread | null) => {
    unread.value = newUnread;
  };

  return { unread, setUnread };
});
